import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function EventTreeInitiatingEventIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle id="path-1" cx="12" cy="12" r="12" />
    </SvgIcon>
  );
}

export default EventTreeInitiatingEventIcon;
